import '@/app/app.css';
import './search.css';

import '@/app/app';
import '@/components/swiper/swiper-buttons/swiper-buttons.css';

import { SwiperButtons } from '@/components/swiper/swiper-buttons/swiper-buttons';
import { initSmartSticky } from '@/features/category/category-aside/smart-sticky';
import { CategoryViewSwitcher } from '@/features/category/category-view-switcher/category-view-switcher';
import { CategoryCards } from '@/components/card/card-category/category-cards';
import { CardProductGallery } from '@/components/card/card-product/card-product-gallery';

document.addEventListener('DOMContentLoaded', () => {
	const swiperButtons = document.querySelector('.js-swiper-buttons');
	swiperButtons && new SwiperButtons(swiperButtons);

	initSmartSticky();

	new CategoryViewSwitcher('.js-category-view-switcher', '.category-products__cards');

	const categoryCards = document.querySelector('.js-category-cards');
	categoryCards && new CategoryCards(categoryCards);

	const cardProductGalleries = document.querySelectorAll('.js-card-product-gallery');
	cardProductGalleries.forEach((gallery) => new CardProductGallery(gallery));
});
